<template>
  <div>
    <transition name="fade">
      <v-overlay :z-index="202 + layer * 2 - 1" v-if="value"></v-overlay>
    </transition>
    <v-dialog
      persistent
      :value="value"
      :max-width="maxWidth"
      scrollable
      hide-overlay
    >
      <v-card class="unmarkable" transition="slide" ref="ButtonSelectionDialog">
        <v-card-title v-if="dialogTitle">
          <v-icon v-if="!!icon">{{ icon }}</v-icon>
          &nbsp;
          {{ dialogTitle }}
        </v-card-title>
        <v-divider v-if="dialogTitle" />
        <v-card-text :style="{ height: '100%' }">
          {{ dialogText }}
          <v-text-field
            v-if="hasFilter"
            v-model="filterText"
            label="Filter"
          ></v-text-field>
          <div v-if="filteredSelection.length === 0">
            Nothing to select from
          </div>
          <v-layout row wrap v-else>
            <v-flex
              v-for="s in filteredSelection"
              xs12
              md6
              lg4
              :key="s.name ? s.name : s"
            >
              <v-card
                color="grey lighten-3"
                :style="{ margin: '3px' }"
                @click="onSelectionClick(s)"
              >
                <v-card-text v-if="s.name">
                  <div>
                    <img
                      :src="s.imagePath"
                      :style="{ height: '1.5em', paddingRight: '10px' }"
                    />
                    {{ s.displayName }} [{{ getUnit(s.showUnit) }}]
                  </div>
                </v-card-text>
                <v-card-text v-else>{{ s }}</v-card-text>
              </v-card>
            </v-flex>
            <v-flex
              v-for="i in selection.length - filteredSelection.length"
              :key="i"
              xs12
              md6
              lg4
              class="hidden"
            >
              <v-card :style="{ margin: '3px' }">
                <v-card-text>a</v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn color="error" text @click="onCancelClick">
            {{ cancelText }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { unitConverter } from "../../utils/unitConverter";

export default {
  name: "ButtonSelectionDialogFromAction",

  data: function() {
    return {
      value: false,
      currentSelection: null,
      filterText: ""
    };
  },

  computed: {
    ...mapState("buttonSelectionDialog", [
      "showDialog",
      "dialogTitle",
      "dialogText",
      "cancelText",
      "maxWidth",
      "onSelection",
      "onCancel",
      "resolve",
      "selection",
      "hasFilter",
      "icon",
      "layer"
    ]),
    filteredSelection() {
      if (this.hasFilter) {
        return this.selection.filter(s =>
          s.toLowerCase().includes(this.filterText.toLowerCase())
        );
      } else {
        return this.selection;
      }
    }
  },

  watch: {
    showDialog(newValue) {
      this.value = newValue;
      this.currentSelection = null;
      this.filterText = "";
    }
  },

  methods: {
    onSelectionClick(newSelection) {
      this.onSelection(newSelection);
      this.resolve({ cancelled: false, result: newSelection });
    },
    onCancelClick() {
      this.onCancel();
      this.resolve({ cancelled: true, result: null });
    },
    getUnit(driveShowUnit) {
      return unitConverter.lookupUnitLabel(driveShowUnit);
    }
  }
};
</script>

<style scoped>
v-layout {
  transition: height 3s !important;
}

.hidden {
  visibility: hidden;
}
</style>
